const isBEV = vehicle => {
  const fuelType = vehicle && vehicle.fuel ? vehicle.fuel : "";
  return ["BEV"].includes(fuelType.toUpperCase());
};

export default isBEV;
